import SendAlert from "../Tools/SendAlert";

const MerchantAlerts = ({ toggleRightBar }) => {
  return (
    <div className="container-fluid">
      <div className="d-flex justify-content-between bg-white mb-5">
        <div className="d-flex justify-content-start al ign-items-center">
          <button
            type="button"
            className="btn-close m-3"
            onClick={toggleRightBar}
          ></button>
          <div className="fs-2 text-dark fw-bold">Merchant Alerts</div>
        </div>
      </div>
      <SendAlert />
    </div>
  );
};

export default MerchantAlerts;